import { useEffect, useState } from 'react';
import { ProductList } from '$domains/essentials/components/ProductList';
import { useGlobalContext } from '../../../contexts';
import itStrings from '../../../core/intl/strings.it.json';
import enStrings from '../../../core/intl/strings.en.json';
import { useGetAvailableCategories } from '$core/api/useGetAvailableCategories';

const CommercePage = () => {
  const { language } = useGlobalContext();
  const strings = language === 'it' ? itStrings : enStrings;

  const [selectedStrumento, setSelectedStrumento] = useState<string>(
    () => localStorage.getItem('selectedStrumento') || strings.violino,
  );
  const [strumentoActiveButton, setStrumentoActiveButton] = useState<string>(
    () => localStorage.getItem('selectedStrumento') || strings.violino,
  );
  const [categoria, setCategoria] = useState('');

  const strumentoMenu = [
    { strumento: strings.violino },
    { strumento: strings.viola },
    { strumento: strings.cello },
  ];

  const { availableCategories, loading } = useGetAvailableCategories(selectedStrumento);

  // Restore category selection from localStorage on mount
  useEffect(() => {
    const storedCat = localStorage.getItem('cat');
    const isSelected = localStorage.getItem('selected') === 'true';
    if (storedCat && isSelected) {
      setCategoria(storedCat);
    }
  }, []);

  // Reset category if it's no longer available for the current strumento/store
  useEffect(() => {
    if (categoria && !availableCategories.includes(categoria as any)) {
      setCategoria('');
      localStorage.removeItem('cat');
      localStorage.removeItem('selected');
    }
  }, [availableCategories, categoria]);

  // Sync selected strumento to localStorage
  useEffect(() => {
    if (selectedStrumento) {
      localStorage.setItem('selectedStrumento', selectedStrumento);
    } else {
      localStorage.removeItem('selectedStrumento');
    }
  }, [selectedStrumento]);

  const handleStrumentoSelection = (strumento: string) => {
    if (strumentoActiveButton === strumento) {
      setSelectedStrumento('');
      setStrumentoActiveButton('');
    } else {
      setSelectedStrumento(strumento);
      setStrumentoActiveButton(strumento);
    }
  };

  const handleCategorySelection = (cat: string) => {
    if (categoria.toLowerCase() === cat.toLowerCase()) {
      localStorage.removeItem('cat');
      localStorage.removeItem('selected');
      setCategoria('');
    } else {
      localStorage.setItem('cat', strings[cat as keyof typeof strings].toLowerCase());
      localStorage.setItem('selected', 'true');
      setCategoria(cat);
    }
  };

  const categoryButtonClass = (cat: string) => `text-sm w-auto bg-button-dark m-1 py-1 px-3 border-2 uppercase text-white
    rounded-xl transition-all duration-300 hover:bg-amber-600 hover:scale-110
    ${categoria.toLowerCase() === cat
    ? 'border-amber-500 bg-amber-700 shadow-lg shadow-amber-500/50'
    : 'border-transparent hover:border-amber-300'}`;

  return (
    <div>
      <div className="pt-4 bg-naturisima-dark">
        <h5 className="text-center text-yellow-500 italic text-sm uppercase">
          {strings.strumento}
        </h5>
        <ul className="flex flex-wrap justify-center">
          {strumentoMenu.map(({ strumento }) => (
            <button
              key={strumento}
              type="button"
              className={`text-sm w-auto bg-button-dark m-1 py-1 px-3 border-2 uppercase text-white rounded-xl ${strumentoActiveButton === strumento ? 'border-amber-500' : 'border-transparent'}`}
              onClick={() => handleStrumentoSelection(strumento)}
            >
              <div>{strumento}</div>
            </button>
          ))}
        </ul>
      </div>

      <div className="text-white bg-naturisima-dark pt-2 pb-1 flex flex-wrap items-center justify-center mx-auto">
        {loading && (
          <div className="w-full flex justify-center py-4">
            <div className="text-yellow-500 text-sm italic">
              Waiting show to load...
            </div>
          </div>
        )}

        {!loading && availableCategories.includes('piroli') && (
          <div>
            <button type="button" className={categoryButtonClass('piroli')} onClick={() => handleCategorySelection('piroli')}>
              <div className="font-semibold">{strings.piroli}</div>
            </button>
          </div>
        )}

        {!loading && availableCategories.includes('mentoniere') && (
          <div>
            <button type="button" className={categoryButtonClass('mentoniere')} onClick={() => handleCategorySelection('mentoniere')}>
              <div className="font-semibold">{strings.mentoniere}</div>
            </button>
          </div>
        )}

        {!loading && availableCategories.includes('cordiere') && (
          <div>
            <button type="button" className={categoryButtonClass('cordiere')} onClick={() => handleCategorySelection('cordiere')}>
              <div className="font-semibold">{strings.cordiere}</div>
            </button>
          </div>
        )}

        {!loading && availableCategories.includes('viti') && (
          <div>
            <button type="button" className={categoryButtonClass('viti')} onClick={() => handleCategorySelection('viti')}>
              <div className="font-semibold">{strings.viti}</div>
            </button>
          </div>
        )}

        {!loading && availableCategories.includes('speciali') && (
          <div>
            <button type="button" className={categoryButtonClass('speciali')} onClick={() => handleCategorySelection('speciali')}>
              <div className="font-semibold">{strings.speciali}</div>
            </button>
          </div>
        )}

        {!loading && availableCategories.includes('servizi') && (
          <div>
            <button type="button" className={categoryButtonClass('servizi')} onClick={() => handleCategorySelection('servizi')}>
              <div className="font-semibold">{strings.servizi}</div>
            </button>
          </div>
        )}
      </div>

      {categoria && (
        <div className="text-left">
          <ProductList
            key={categoria}
            cat={categoria}
            selectedStrumento={selectedStrumento}
          />
        </div>
      )}
    </div>
  );
};

export { CommercePage };
